const PIXEL_ID = '1720113316016666'

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

let initialized = false

/**
 * Loads the Meta Pixel base code, initializes the pixel, and fires PageView.
 * Safe to call multiple times — it only initializes once.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  try {
    /* eslint-disable */
    ;(function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return
      const n: any = (f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      const s = b.getElementsByTagName(e)[0]
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s)
      } else {
        ;(b.head || b.documentElement).appendChild(t)
      }
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )
    /* eslint-enable */

    window.fbq?.('init', PIXEL_ID)
    window.fbq?.('track', 'PageView')
  } catch (err) {
    // The pixel must never break the page (e.g. blocked by an ad-blocker,
    // a sandboxed preview iframe, or a Content-Security-Policy restriction).
    console.warn('Meta Pixel init skipped:', err)
  }
}

/** Fires the standard Meta Pixel AddToCart event. */
export function trackAddToCart(): void {
  if (typeof window === 'undefined') return
  try {
    window.fbq?.('track', 'AddToCart')
  } catch (err) {
    console.warn('Meta Pixel AddToCart skipped:', err)
  }
}
